var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.form.idcardImg ? _vm.getFullPath(_vm.form.idcardImg) : null
  var m1 = _vm.form.idcardImgBack
    ? _vm.getFullPath(_vm.form.idcardImgBack)
    : null
  var l0 = _vm.__map(_vm.form.storeFrontImgs, function (img, index) {
    var $orig = _vm.__get_orig(img)
    var m2 = _vm.getFullPath(img)
    return {
      $orig: $orig,
      m2: m2,
    }
  })
  var l1 = _vm.__map(_vm.form.storeInteriorImgs, function (img, index) {
    var $orig = _vm.__get_orig(img)
    var m3 = _vm.getFullPath(img)
    return {
      $orig: $orig,
      m3: m3,
    }
  })
  var l2 = _vm.__map(_vm.form.otherMaterialImgs, function (img, index) {
    var $orig = _vm.__get_orig(img)
    var m4 = _vm.getFullPath(img)
    return {
      $orig: $orig,
      m4: m4,
    }
  })
  var l3 =
    _vm.form.companyType === 0
      ? _vm.__map(_vm.form.laborContractImgs, function (img, index) {
          var $orig = _vm.__get_orig(img)
          var m5 = _vm.getFullPath(img)
          return {
            $orig: $orig,
            m5: m5,
          }
        })
      : null
  var l4 =
    _vm.form.companyType === 0
      ? _vm.__map(_vm.form.socialSecurityImgs, function (img, index) {
          var $orig = _vm.__get_orig(img)
          var m6 = _vm.getFullPath(img)
          return {
            $orig: $orig,
            m6: m6,
          }
        })
      : null
  var m7 =
    !(_vm.form.companyType === 0) && _vm.form.legalPersonCard
      ? _vm.getFullPath(_vm.form.legalPersonCard)
      : null
  var m8 =
    !(_vm.form.companyType === 0) && _vm.form.legalPersonCardBack
      ? _vm.getFullPath(_vm.form.legalPersonCardBack)
      : null
  var m9 =
    !(_vm.form.companyType === 0) && _vm.form.businessImg
      ? _vm.getFullPath(_vm.form.businessImg)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
        l1: l1,
        l2: l2,
        l3: l3,
        l4: l4,
        m7: m7,
        m8: m8,
        m9: m9,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }